import React from 'react';

/** Horizontal colour legend under the plot. `colors` = swatches, `ticks` = labels spread evenly along the bar. */
export default function SectionLegendBottom({ x, y, w, colors, ticks, unit, textProps, testId }) {
  const n = colors.length;
  return (
    <g data-testid={testId}>
      {colors.map((c, i) => <rect key={i} x={x + (i / n) * w} y={y} width={w / n + 0.5} height={10} fill={c} />)}
      {ticks.map((t, i) => (
        <text key={i} {...textProps} x={x + (ticks.length > 1 ? (i / (ticks.length - 1)) * w : 0)} y={y + 22} textAnchor="middle">{t}</text>
      ))}
      <text {...textProps} x={x + w + 8} y={y + 9} textAnchor="start">{unit}</text>
    </g>
  );
}
